<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.25 10.626L36.7905 24.3735L23.25 37.374" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
<path d="M11.25 10.626L24.7905 24.3735L11.25 37.374" stroke="black" stroke-width="2" stroke-miterlimit="10"/>
</svg>
